import React from 'react'
import { useParams } from 'react-router-dom'
import { useRedirectTo } from '@@partner:helpers/hooks/location'

import { Panel } from 'rsuite'
import BannerTypeForm from '@components/marketing/banners/type/BannerTypeForm'

import { ROUTE_MARKETING_BANNER_TYPE } from '@@partner:config/routes'

export default function BannerTypeFormPage () {
  const { bannerTypeId, brandSlug } = useParams<any>()
  const redirectToBannerTypes = useRedirectTo(ROUTE_MARKETING_BANNER_TYPE, {
    brandSlug
  })

  return (
    <div className="BannerTypesPage">
      <h1 className="u-heading">
        {bannerTypeId ? 'Редактирование' : 'Добавление'}
      </h1>
      <Panel shaded>
        <BannerTypeForm
          bannerTypeId={bannerTypeId}
          onSaved={redirectToBannerTypes}
        />
      </Panel>
    </div>
  )
}
